import { render, staticRenderFns } from "./BTableUsersActions.vue?vue&type=template&id=44c2cabe&"
import script from "./BTableUsersActions.vue?vue&type=script&lang=js&"
export * from "./BTableUsersActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports